<h2 matDialogTitle class="visually-hidden">Frequency scheduling</h2>
<div class="dialog-container">
  <!-- <div class="header-wrapper">
    @if (title) {
      <span class="dark font-bold font-20">{{
        title | translate
      }}</span>
    }
    <div class="icon-wrapper" matDialogClose>
      <i class="bi bi-x-lg"></i>
    </div>
  </div> -->
  <div class="content-wrapper">
    <!-- modal body  -->
    @if (isLoading) {
    <app-loader class="w-100"></app-loader>
    } @if (!isLoading) {
    <div>
      <div class="next-date-container">
        @if (frequencyData) {
        <div class="date">
          <div>
            <span>{{ "Next-Date" | translate }}</span>
            <span> : </span>
            <span
              >{{frequencyData?.startDate ? (frequencyData?.startDate + 'Z' |
              date:'dd/MM/yyy'): '--' }}</span
            >
          </div>
          <div>
            <span> {{ "Time" | translate }} </span>
            <span> : </span>
            <span
              >{{frequencyData?.time ? getFormattedTime(frequencyData?.time) :
              '' }}</span
            >
          </div>
        </div>
        }
        <div class="delete-btn">
          <button
            class="delete-btn-icon d-block m-auto"
            type="button"
            (click)="deleteNextDate()">
            <i class="bi bi-trash"></i>
            <span> {{ "Actions-List.Delete" | translate }} </span>
          </button>
        </div>
      </div>
      <form class="mt-3" [formGroup]="form">
        <div class="row">
          <!-- frequency type -->
          <div class="col-6">
            <app-custom-select
              [label]="'Frequency'"
              [required]="false"
              [items]="frequencyTypes"
              bindLabel="name"
              bindValue="id"
              placeholder="{{ 'Common-Label.PH-Select' | translate }} {{ 'Frequency' | translate }}"
              formControlName="frequencyType"
              (clear)="getFrequencyTypes()"
              (open)="getFrequencyTypes()"></app-custom-select>
          </div>

          <!-- date  -->
          @if (selectedFrequency === frequencyType.Once) {
          <div class="col-6">
            <label class="mt-3"
              >{{ "Date" | translate }}
              <span class="required-asterisk">*</span></label
            >
            <!-- <input type="date" formControlName="date" /> -->
            <app-date-picker formControlName="date"> </app-date-picker>
            <!-- @if (form.get('date')?.touched && form.get('date')?.errors) {
            <mat-error>
              @if ((form.get('date')?.errors)!['required']) {
              <div class="error-msg">
                {{ "Validations.Required" | translate }}
              </div>
              }
            </mat-error>
            } -->
          </div>
          }

          <!-- start date  -->
          @if (selectedFrequency !== frequencyType.Once) {
          <div class="col-6">
            <label class="mt-3"
              >{{ "Start-Date" | translate }}
              <span class="required-asterisk">*</span></label
            >
            <!-- <input type="date" formControlName="startDate" /> -->
            <app-date-picker formControlName="startDate"> </app-date-picker>
            <!-- @if (form.get('startDate')?.touched && form.get('startDate')?.errors) {
            <mat-error>
              @if ((form.get('startDate')?.errors)!['required']) {
              <div class="error-msg">
                {{ "Validations.Required" | translate }}
              </div>
              }
            </mat-error>
            } -->
          </div>
          }

          <!-- end Date  -->
          @if (selectedFrequency !== frequencyType.Once) {
          <div class="col-6">
            <label class="mt-3"
              >{{ "End-Date" | translate }}
              <span class="required-asterisk">*</span></label
            >
            <!-- <input type="date" formControlName="endDate" /> -->
            <app-date-picker formControlName="endDate"> </app-date-picker>
            <!-- @if (form.get('endDate')?.touched && form.get('endDate')?.errors) {
            <mat-error>
              @if ((form.get('endDate')?.errors)!['required']) {
              <div class="error-msg">
                {{ "Validations.Required" | translate }}
              </div>
              }
            </mat-error>
            } -->
          </div>
          }

          <!--  time  -->
          <div class="col-6">
            <label class="mt-3"
              >{{ "Time" | translate }}
              <span class="required-asterisk">*</span></label
            >
            <input
              type="time"
              formControlName="time"
              [ngClass]="{ 'input-time--rtl': currentLanguage === 'ar' }" />
            @if (form.get('time')?.touched && form.get('time')?.errors) {
            <mat-error>
              @if ((form.get('time')?.errors)!['required']) {
              <div class="error-msg">
                {{ "Validations.Required" | translate }}
              </div>
              }
            </mat-error>
            }
          </div>

          <!-- repeat every -->
          @if (selectedFrequency !== frequencyType.Once) {
          <div class="col-6 mt-3">
            <label>
              {{ "Repeate-Every" | translate }}
              <span class="required-asterisk">*</span>
            </label>
            <input
              type="number"
              formControlName="repeat"
              min="1"
              max="99"
              (blur)="blurEventToResetInputValueToOne('repeat')"
              (keydown)="restrictNumberInput($event)"
              (input)="checkNumberRange($event)" />
          </div>
          }

          <!-- daily repeats on weekly choice  -->
          @if (selectedFrequency === frequencyType.Weekly) {
          <div class="col-6 mt-1">
            <label class="mt-3"> {{ "Repeate-Every" | translate }} </label>
            <div class="weeks-container">
              @for (week of weeks; track week) {
              <span
                [id]="week.id"
                class="week"
                (click)="selectDayFromWeeklyFrequency(week)"
                [class.active]="week.isActive">
                {{ currentLanguage === "en" ? week.nameEn : week.nameAr }}
              </span>
              }
            </div>
          </div>
          }

          <!-- daily repeats on monthly choice  -->
          @if (selectedFrequency === frequencyType.Monthly) {
          <div class="col-6 mt-1">
            <label class="mt-3"> {{ "" | translate }} </label>
            <div class="options-container">
              <div class="option-container">
                <div class="form-radio">
                  <input
                    type="radio"
                    class="form-radio-input"
                    id="onDayInput"
                    value="c1"
                    formControlName="monthChoice" />

                  <label class="form-radio-label mx-2" for="onDayInput">
                    {{ "On-Day" | translate }}
                  </label>
                </div>
                <div class="day-input">
                  <!-- day input  -->
                  <input
                    type="number"
                    formControlName="dayNumberMonthChoice"
                    min="1"
                    max="31"
                    (blur)="
                          blurEventToResetInputValueToOne('dayNumberMonthChoice')
                        "
                    (keydown)="restrictNumberInput($event)"
                    (input)="checkNumberRange($event)" />
                </div>
              </div>
              <div class="second-select">
                <div class="form-radio">
                  <input
                    type="radio"
                    class="form-radio-input"
                    id="onDaySelect"
                    value="c2"
                    formControlName="monthChoice" />
                  <label class="form-radio-label mx-2" for="onDaySelect">
                    {{ "On-The" | translate }}
                  </label>
                </div>
                <div class="select-container">
                  <!-- day select  -->
                  <div class="select-one">
                    <app-custom-select
                      [label]="''"
                      [styleClass]="'mt-0 d-none'"
                      [required]="false"
                      [items]="parts"
                      bindLabel="{{currentLanguage === 'en' ? 'nameEn' : 'nameAr'}}"
                      bindValue="id"
                      formControlName="partNumberMonthChoice"></app-custom-select>
                  </div>
                  <div class="select-two">
                    <app-custom-select
                      [label]="''"
                      [styleClass]="'mt-0 d-none'"
                      [required]="false"
                      [items]="weeks"
                      bindLabel="{{currentLanguage === 'en' ? 'fullNameEn' : 'fullNameAr'}}"
                      bindValue="id"
                      formControlName="dayNameMonthChoice"></app-custom-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }

          <!-- daily repeats on yearly choice  -->
          @if (selectedFrequency === frequencyType.Yearly) {
          <div class="col-6 mt-1">
            <label class="mt-3"> {{ "" | translate }} </label>
            <div class="options-container">
              <div class="option-container">
                <div class="form-radio">
                  <input
                    type="radio"
                    class="form-radio-input"
                    id="yearChoiceOne"
                    value="c1"
                    formControlName="yearChoice" />

                  <label class="form-radio-label mx-2" for="yearChoiceOne">
                    {{ "On" | translate }}
                  </label>
                </div>
                <div class="yearly-first-choice-container">
                  <!-- month select  -->
                  <div class="select-one">
                    <app-custom-select
                      [label]="''"
                      [styleClass]="'mt-0 d-none'"
                      [required]="false"
                      [items]="months"
                      bindLabel="{{currentLanguage === 'en' ? 'nameEn' : 'nameAr'}}"
                      bindValue="id"
                      formControlName="monthChoiceFirstYearly"></app-custom-select>
                  </div>
                  <div class="day-input">
                    <!-- day input  -->
                    <input
                      type="number"
                      formControlName="dayNumFirstYearly"
                      min="1"
                      max="31"
                      (blur)="
                            blurEventToResetInputValueToOne('dayNumFirstYearly')
                          "
                      (keydown)="restrictNumberInput($event)"
                      (input)="checkNumberRange($event)" />
                  </div>
                </div>
              </div>
              <div class="second-select">
                <div class="form-radio">
                  <input
                    type="radio"
                    class="form-radio-input"
                    id="yearChoiceTwo"
                    value="c2"
                    formControlName="yearChoice" />
                  <label class="form-radio-label mx-2" for="yearChoiceTwo">
                    {{ "On-The" | translate }}
                  </label>
                </div>
                <div class="yearly-select-container">
                  <!-- part select  -->
                  <div class="yearly-select-one">
                    <app-custom-select
                      [label]="''"
                      [styleClass]="'mt-0 d-none'"
                      [required]="false"
                      [items]="parts"
                      bindLabel="{{currentLanguage === 'en' ? 'nameEn' : 'nameAr'}}"
                      bindValue="id"
                      formControlName="partChoiceSecondYearly"></app-custom-select>
                  </div>
                  <!-- week select  -->
                  <div class="yearly-select-two">
                    <app-custom-select
                      [label]="''"
                      [styleClass]="'mt-0 d-none'"
                      [required]="false"
                      [items]="weeks"
                      bindLabel="{{currentLanguage === 'en' ? 'fullNameEn' : 'fullNameAr'}}"
                      bindValue="id"
                      formControlName="dayNameChoiceSecondYearly"></app-custom-select>
                  </div>
                  <span> {{ "Of" | translate }} </span>
                  <!-- month select  -->
                  <div class="yearly-select-three">
                    <app-custom-select
                      [label]="''"
                      [styleClass]="'mt-0 d-none'"
                      [required]="false"
                      [items]="months"
                      bindLabel="{{currentLanguage === 'en' ? 'nameEn' : 'nameAr'}}"
                      bindValue="id"
                      formControlName="monthNameSecondYearly"></app-custom-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }

          <!-- frequency msg  -->
          @if (selectedFrequency) {
          <div class="frequency-msg">
            <!-- no repeate msg  -->
            @if (selectedFrequency === frequencyType.Once) {
            <ng-container>
              @if (form.get('date')?.value) {
              <span>
                {{ "Occurs-On" | translate }} {{ form.get("date")?.value | date
                : "dd/MM/yyyy" }}
              </span>
              } @if (form.get('time')?.value) {
              <span>
                {{ "At" | translate }} {{
                getFormattedTime(form.get("time")?.value) }}
              </span>
              }
            </ng-container>
            }

            <!-- daily msg  -->
            @if (selectedFrequency === frequencyType.Daily) {
            <ng-container>
              <span>
                <span>{{ "Occurs-Every" | translate }}</span>
                @if (+form.get('repeat')?.value === 1) {
                <span> {{ "Day" | translate }}</span>
                } @if (+form.get('repeat')?.value > 1) {
                <span>
                  {{ form.get("repeat")?.value }} {{ "Days" | translate }}
                </span>
                }
              </span>
              @if (form.get('startDate')?.value) {
              <span>
                {{ "Starting" | translate }} {{ form.get("startDate")?.value |
                date : "dd/MM/yyyy" }}
              </span>
              } @if (form.get('endDate')?.value) {
              <span>
                {{ "Until" | translate }} {{ form.get("endDate")?.value | date :
                "dd/MM/yyyy" }}
              </span>
              } @if (form.get('time')?.value) {
              <span>
                {{ "At" | translate }} {{
                getFormattedTime(form.get("time")?.value) }}
              </span>
              }
            </ng-container>
            }

            <!-- weekly msg  -->
            @if (selectedFrequency === frequencyType.Weekly) {
            <ng-container>
              <span>
                <span>{{ "Occurs-Every" | translate }}</span>
                @if (+form.get('repeat')?.value > 1) {
                <span>
                  {{ form.get("repeat")?.value }} {{ "Weeks" | translate }}
                </span>
                } @if (+form.get('repeat')?.value > 1) {
                <span> {{ "On" | translate }}</span>
                }
              </span>
              <span>
                @if (allActiveWeekCount < 7 || +form.get('repeat')?.value> 1) {
                <span>
                  @for (w of weeks; track w) { @if (w.isActive) {
                  <span>
                    {{ currentLanguage === "en" ? w.fullNameEn : w.fullNameAr }}
                    ,</span
                  >
                  } }
                </span>
                } @if (allActiveWeekCount == 7 && +form.get('repeat')?.value ===
                1) {
                <span> {{ "Day" | translate }}</span>
                }
              </span>
              @if (form.get('startDate')?.value) {
              <span>
                {{ "Starting" | translate }} {{ form.get("startDate")?.value |
                date : "dd/MM/yyyy" }}
              </span>
              } @if (form.get('endDate')?.value) {
              <span>
                {{ "Until" | translate }} {{ form.get("endDate")?.value | date :
                "dd/MM/yyyy" }}
              </span>
              } @if (form.get('time')?.value) {
              <span>
                {{ "At" | translate }} {{
                getFormattedTime(form.get("time")?.value) }}
              </span>
              }
            </ng-container>
            }

            <!-- monthly msg  -->
            @if (selectedFrequency === frequencyType.Monthly) {
            <ng-container>
              <span>
                <span>{{ "Occurs-Every" | translate }}</span>
                @if (+form.get('repeat')?.value === 1) {
                <span> {{ "Month" | translate }}</span>
                } @if (+form.get('repeat')?.value > 1) {
                <span>
                  {{ form.get("repeat")?.value }} {{ "Months" | translate }}
                </span>
                }
              </span>
              @if (form.get('monthChoice')?.value === 'c1') {
              <span>
                {{ "On" | translate }} {{ "Day" | translate }} {{
                form.get("dayNumberMonthChoice")?.value }}
              </span>
              } @if (form.get('monthChoice')?.value === 'c2') {
              <span>
                {{ "On" | translate }} {{ "The" | translate }} {{
                selectedPartNameInMonthlyFrequency }} {{
                selectedDayNameInMonthlyFrequency }}
              </span>
              } @if (form.get('startDate')?.value) {
              <span>
                {{ "Starting" | translate }} {{ form.get("startDate")?.value |
                date : "dd/MM/yyyy" }}
              </span>
              } @if (form.get('endDate')?.value) {
              <span>
                {{ "Until" | translate }} {{ form.get("endDate")?.value | date :
                "dd/MM/yyyy" }}
              </span>
              } @if (form.get('time')?.value) {
              <span>
                {{ "At" | translate }} {{
                getFormattedTime(form.get("time")?.value) }}
              </span>
              }
            </ng-container>
            }

            <!-- yearly msg  -->
            @if (selectedFrequency === frequencyType.Yearly) {
            <ng-container>
              <span>
                <span>{{ "Occurs-Every" | translate }}</span>
                @if (+form.get('repeat')?.value === 1) {
                <span> {{ "Year" | translate }}</span>
                } @if (+form.get('repeat')?.value > 1) {
                <span>
                  {{ form.get("repeat")?.value }} {{ "Years" | translate }}
                </span>
                }
              </span>
              @if (form.get('yearChoice')?.value === 'c1') {
              <span>
                {{ "On" | translate }} {{ "Day" | translate }} {{
                form.get("dayNumFirstYearly")?.value }} {{ "Of" | translate }}
                {{ selectedMonthNameInYearlyFrequencyFirstChoice }}
              </span>
              } @if (form.get('yearChoice')?.value === 'c2') {
              <span>
                {{ "On" | translate }} {{ "The" | translate }} {{
                selectedPartNameInYearlyFrequencySecondChoice }} {{
                selectedDayNameInYearlyFrequencySecondChoice }}
                <span> {{ "Of" | translate }} </span>
                {{ selectedMonthNameInYearlyFrequencySecondChoice }}
              </span>
              } @if (form.get('startDate')?.value) {
              <span>
                {{ "Starting" | translate }} {{ form.get("startDate")?.value |
                date : "dd/MM/yyyy" }}
              </span>
              } @if (form.get('endDate')?.value) {
              <span>
                {{ "Until" | translate }} {{ form.get("endDate")?.value | date :
                "dd/MM/yyyy" }}
              </span>
              } @if (form.get('time')?.value) {
              <span>
                {{ "At" | translate }} {{
                getFormattedTime(form.get("time")?.value) }}
              </span>
              }
            </ng-container>
            }
          </div>
          }
        </div>
      </form>
    </div>
    }
  </div>
  <div class="footer-wrapper">
    <button class="cancelBtn" matDialogClose>
      {{"Actions-List.Cancel"| translate }}
    </button>
    <button class="primary save" (click)="submit()" [disabled]="!form.valid">
      {{ "Actions-List.Save" | translate }}
    </button>
  </div>
</div>
